import { type RefObject, useEffect } from "react";

type Event = MouseEvent | TouchEvent;

const doesParentHaveClass = (target: any, selector: string): boolean => {
  if (!target) {
    return false;
  }

  if (target?.classList?.contains("react-joyride__tooltip")) {
    return true;
  }

  return doesParentHaveClass(target.parentNode, selector);
};

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T | null>,
  handler: (event: Event) => void
) {
  useEffect(() => {
    const listener = (event: Event) => {
      const el = ref?.current;
      // Do nothing if clicking ref's element or descendent elements
      if (!el || el.contains((event?.target as Node) || null)) {
        return;
      }

      // Never close the modals if the user is inside a tour
      if (
        doesParentHaveClass((event as any)?.target, "react-joyride__tooltip")
      ) {
        return;
      }
      handler(event);
    };

    document.addEventListener(`mousedown`, listener);
    document.addEventListener(`touchstart`, listener);

    return () => {
      document.removeEventListener(`mousedown`, listener);
      document.removeEventListener(`touchstart`, listener);
    };
    // Reload only if ref or handler changes
  }, [ref, handler]);
}
